import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { delayedRetry } from '@ridango/core/lib/operators/delayed-retry';

import { Angulartics2 } from 'angulartics2';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BankcardTicket } from './model/bankcard-ticket.model';
import { BankcardTransaction } from './model/bankcard-transaction.model';
import Env from '@ridango/core/env';

@Injectable({
    providedIn: 'root'
})
export class BankcardTicketsService {
    constructor(
        @Inject('ENV') private env: Env,
        private http: HttpClient,
        private angulartics2: Angulartics2
    ) {}

    fetchTransaction(regionId: number): Observable<BankcardTransaction> {
        const url = `${this.env.API_BASE_URL}/${regionId}/emv/transaction`;
        return this.http.get(url).pipe(map((response: BankcardTransaction) => response));
    }

    fetchTickets(payload): Observable<BankcardTicket[]> {
        const url = `${this.env.CORE_API_URL}/customer/v1/region/${this.env.REGION_ID}/emv/${payload.transactionId}/tickets`;
        const params: Record<string, string> = { lang: payload.lang };
        if (this.env.CHANNEL) {
            params.channel = this.env.CHANNEL;
        }
        return this.http
            .get(url, { params })
            .pipe(delayedRetry(2000, 3, 'TPS_HAS_NOT_RESPONDED_TO_TRANSACTION'))
            .pipe(map((response: BankcardTicket[]) => response));
    }

    fetchHslTickets(transactionId: number): Observable<BankcardTicket[]> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/emv/${transactionId}/hsl-tickets`;
        return this.http
            .get(url)
            .pipe(delayedRetry(2000, 3, 'TPS_HAS_NOT_RESPONDED_TO_TRANSACTION'))
            .pipe(map((response: BankcardTicket[]) => response));
    }

    fetchPDF(token: string, lang: string): Observable<any> {
        const payload = {
            jwt: token,
            lang: lang
        };
        this.angulartics2.eventTrack.next({
            action: 'download',
            properties: { category: 'pdf', label: 'from BankcardTicketsService' }
        });
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/pdf`;
        return this.http.put(url, payload, { responseType: 'blob' });
    }

    sendFeedback(formData) {
        const url = `${this.env.API_BASE_OLD_URL}/regions/${this.env.REGION_ID}/support/emv.json`;
        const headers = new HttpHeaders().set('Content-Type', 'application/json, charset=utf-8');
        const payload = {
            transaction_id: formData.transaction_id,
            client_name: formData.client_name,
            client_phone: formData.client_phone,
            client_email: formData.client_email,
            client_problem_description: formData.client_problem_description
        };

        return this.http.put(url, JSON.stringify(payload), { headers: headers }).pipe(map((response: any) => response));
    }
}
